import React, { useEffect, useState } from "react";
import { statecityData } from "../../shared/enums";
import GlobalButton from "../../shared/utils/GlobalButton";
import Styles from "../../styles/vendorDashboard.module.css";
import CheckIcon from "@mui/icons-material/Check";
import { validate } from "../../shared/utils/validation";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import { Cross } from "../../shared/assets/icons/index";
import CustomInput from "../../shared/utils/Input";
import axios from "axios";
import Swal from "sweetalert2";
import "./vendorOnboard.css";
import MinMaxFileUploader from "../utils/minmaxFileUploader";
import { itiCoursesList } from "../../shared/enums";
import GlobalDropdownField from "../utils/GlobalDropdownField";
import { KeyboardArrowDown } from "@mui/icons-material";
import Decrypt from "../utils/Decrypt";
// Prevent mouse wheel from changing number inputs
const handleWheel = (e) => {
  e.target.blur(); // Remove focus to prevent wheel scroll
};

// Add event listener on focus
const handleFocus = (e) => {
  e.target.addEventListener("wheel", handleWheel, { passive: false });
};

// Remove event listener on blur
const handleBlur = (e) => {
  e.target.removeEventListener("wheel", handleWheel);
};

const InstallationPartnerOnboardingForm = ({
  isModalOpen,
  setIsModalOpen,
  selectedInstallationPartnerData,
  setSelectedInstallationPartnerData,
  getInstallationPartnerList,
  setSnackbar,
  fetchIps,
  searchInputs,
  pageSize,
}) => {
  const [formData, setFormData] = useState({
    name: selectedInstallationPartnerData?.name || "",
    gender: selectedInstallationPartnerData?.gender || "",
    dateOfBirth:
      selectedInstallationPartnerData?.dateOfBirth?.split("T")[0] || "",
    tenthCertificate: selectedInstallationPartnerData?.tenthCertificate,
    twelfthCertificate: selectedInstallationPartnerData?.twelfthCertificate,
    graduationCertificate:
      selectedInstallationPartnerData?.graduationCertificate,
    diplomaCertificate: selectedInstallationPartnerData?.diplomaCertificate,
    itiCertificate: selectedInstallationPartnerData?.itiCertificate,
    address: selectedInstallationPartnerData?.address || "",
    experience: selectedInstallationPartnerData?.experience || "",
    priorKnowledgeOfInstallation:
      selectedInstallationPartnerData?.priorKnowledgeOfInstallation || false,
    phoneNumber: selectedInstallationPartnerData?.phoneNumber || "",
    emailAddress: selectedInstallationPartnerData?.emailAddress || "",
    city: selectedInstallationPartnerData?.city || "",
    state: selectedInstallationPartnerData?.state || "",
    zipCode: selectedInstallationPartnerData?.zipCode || "",
    isTestPassed: selectedInstallationPartnerData?.isTestPassed || false,
    status: selectedInstallationPartnerData?.status || "Active",
    reasonForBlacklisted:
      selectedInstallationPartnerData?.reasonForBlacklisted || "",
    vendorId: selectedInstallationPartnerData?.vendorId || "",
    bankDetails: {
      IFSC: selectedInstallationPartnerData?.bankDetails?.IFSC || "",
      bankName: selectedInstallationPartnerData?.bankDetails?.bankName || "",
      bankHolderName:
        selectedInstallationPartnerData?.bankDetails?.bankHolderName || "",
      cancelledCheque:
        selectedInstallationPartnerData?.bankDetails?.cancelledCheque || "",
      accountNumber:
        selectedInstallationPartnerData?.bankDetails?.accountNumber || "",
      panNumber: selectedInstallationPartnerData?.bankDetails?.panNumber || "",
      installationRate:
        selectedInstallationPartnerData?.bankDetails?.installationRate || "",
    },
    // bankDetails: selectedInstallationPartnerData?.bankDetails || {},
    aadhaarCardNumber: selectedInstallationPartnerData?.aadhaarCardNumber || "",
    ipCategory: selectedInstallationPartnerData?.ipCategory || "",
    profilePhoto: selectedInstallationPartnerData?.profilePhoto || "",
    itiCourse: selectedInstallationPartnerData?.itiCourse || "",
    addedBy: localStorage.getItem("userId"),
    updatedBy: localStorage.getItem("userId"),
  });
  const [requiredFields, setRequiredFields] = useState({
    name: false,
    gender: false,
    address: false,
    phoneNumber: false,
    emailAddress: false,
    experience: false,
    state: false,
    city: false,
    zipCode: false,
  });

  // other
  // const [disableSaveButton, setDisableSaveButton] = useState();
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [vpList, setVPList] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState("");

  const [saveButtonClicked, setSaveButtonClicked] = useState(false);
  const cityApiKey = process.env.REACT_APP_FETCH_STATE_CITY_API_KEY;
  const serverURL = process.env.REACT_APP_URL;

  const today = new Date();
  const maxDate = new Date(
    today.getFullYear() - 18,
    today.getMonth(),
    today.getDate(),
  )
    .toISOString()
    .split("T")[0]; // Format the date in YYYY-MM-DD

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevFormData) => {
      const nameParts = name.split(".");

      // Handle nested objects
      if (nameParts.length === 2) {
        const [objectName, key] = nameParts;
        return {
          ...prevFormData,
          [objectName]: {
            ...prevFormData[objectName],
            [key]: value,
          },
        };
      } else {
        // Clear city field if state changes
        if (name === "state") {
          return {
            ...prevFormData,
            [name]: value,
            city: "", // Clear the city field
          };
        }

        // Handle top-level fields normally
        return {
          ...prevFormData,
          [name]: value,
        };
      }
    });

    // Reset errors or perform validation here if needed
    setErrors((prevErrors) => ({
      ...prevErrors,
      city: "", // Clear errors for city field when state changes
    }));
  };

  const emptyInputCheck = (fieldName, value) => {
    if (value === "") {
      setRequiredFields({ ...requiredFields, [fieldName]: true });
    } else {
      setRequiredFields({ ...requiredFields, [fieldName]: false });
    }
  };
  const getVPList = async () => {
    try {
      const response = await axios.get(`${serverURL}/api/vendorsForMap`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        params: {
          adminApproval: 1,
        },
      });

      if (response?.data?.success) {
        let decreryptedVPs = response?.data.data.map((ele) => {
          return {
            address: ele.address,
            city: ele.city,
            phoneNumber: Decrypt(ele.phoneNumber),
            id: ele.id,
            vendorBusinessName: ele.vendorBusinessName,
            profilePhoto: ele.profilePhoto,
          };
        });
        setVPList(decreryptedVPs || []);
      }
    } catch (error) {
      console.error("Error fetching Vendor Partners:", error);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "State is required";
    if (!formData.gender) newErrors.gender = "Gender is required";
    if (!formData.experience) newErrors.experience = "Experience is required";
    if (
      !formData.emailAddress ||
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.emailAddress)
    ) {
      newErrors.emailAddress = "Valid Email is required";
    }

    if (!formData.aadhaarCardNumber)
      newErrors.aadhaarCardNumber = "Aadhaar Card is required";
    if (!formData.state) newErrors.state = "State is required";
    if (!formData.city) newErrors.city = "City is required";
    if (!formData.dateOfBirth)
      newErrors.dateOfBirth = "Date of Birth is required";
    if (!formData.address) newErrors.address = "Address is required";
    if (!formData.profilePhoto || formData.profilePhoto.length === 0) {
      newErrors.profilePhoto = "Profile photo is required";
    }
    if (!formData.zipCode) newErrors.zipCode = "Zip Code is required";

    if (!formData.phoneNumber || !/^\d{10}$/.test(formData.phoneNumber))
      newErrors.phoneNumber = "Phone Number is required";
    if (formData.status === "Blacklisted" && !formData.reasonForBlacklisted)
      newErrors.reasonForBlacklisted = "Please enter a reason for blacklist";

    setErrors(newErrors);
    if (formData.zipCode && !/^\w{6}$/.test(formData.zipCode))
      newErrors.zipCode = "ZipCode is not valid";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setSelectedInstallationPartnerData({});
  };
  const [cityArray, setCityArray] = useState([]);

  useEffect(() => {
    getVPList();

    const stateCode = statecityData.find(
      (ele) => ele.name === formData.state,
    )?.iso2;

    if (formData.state) {
      const fetchCities = async (stateCode) => {
        const headers = new Headers();
        headers.append("X-CSCAPI-KEY", cityApiKey);

        const requestOptions = {
          method: "GET",
          headers: headers,
          redirect: "follow",
        };

        try {
          const response = await fetch(
            `https://api.countrystatecity.in/v1/countries/IN/states/${stateCode}/cities`,
            requestOptions,
          );

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          const cityData = await response.json();
          setCityArray(cityData);

          // Log the city names
        } catch (error) {
          console.error("Error fetching cities:", error);
        }
      };

      // Example usage: Fetch cities in Maharashtra (state code "MH")
      fetchCities(stateCode);
    }
  }, [formData.state]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      Swal.fire({
        customClass: {
          container: "my-swal",
        },
        icon: "error",
        text: "Something Went Wrong in Validation",
        color: "black",
      });
    } else {
      try {
        if (selectedInstallationPartnerData._id) {
          // Update existing vendor
          try {
            const updatedFormData = {
              ...formData,
            };
            setIsLoading(true);
            const response = await axios.patch(
              `${serverURL}/installationPartner/edit/${selectedInstallationPartnerData._id}`,
              updatedFormData,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
              },
            );

            if (response.data.success) {
              setSnackbar({
                open: true,
                message: "Installation Partner Update Successfully",
                severity: "success",
              });
              setIsModalOpen(false);
              const queryParams = new URLSearchParams();

              Object.entries(searchInputs).forEach(([key, value]) => {
                if (value?.trim()) {
                  queryParams.append(key, value);
                }
              });

              queryParams.append("page", 1);
              queryParams.append("limit", pageSize);

              fetchIps(queryParams.toString());
            } else {
              Swal.fire({
                customClass: {
                  container: "my-swal",
                },
                icon: "error",
                text: response.data.error,
                padding: "1em",
                color: "black",
              });
            }
          } catch (error) {
            console.error("Error updating Installation Partner:", error);
            Swal.fire({
              customClass: {
                container: "my-swal",
              },
              icon: "error",
              title: error.response.data.error,
              text: error.error,
              padding: "1em",
            });
          }
        } else {
          try {
            const updatedFormData = {
              ...formData,
              onboardedBy: "web",
            };

            setIsLoading(true);
            const response = await axios.post(
              `${serverURL}/installationPartner/add`,
              updatedFormData,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
              },
            );
            if (response.data.success) {
              setSnackbar({
                open: true,
                message: response.data.message,
                severity: "success",
              });

              setIsModalOpen(false);
              getInstallationPartnerList();
            } else {
              Swal.fire({
                customClass: {
                  container: "my-swal",
                },
                icon: "error",
                text: response.data.error,
                padding: "1em",
                color: "black",
              }).then(() => {
                // setIsModalOpen(false);
                // getInstallationPartnerList();
              });
            }
          } catch (error) {
            console.error("Error creating Installation Partner:", error);
            setIsLoading(true);
            Swal.fire({
              customClass: {
                container: "my-swal",
              },
              icon: "error",
              title: error.response.data.error,
              text: `Error in creating Installation Partner !`,

              color: "black",
            });
          }
        }
      } catch (globalError) {
        setIsLoading(true);
        console.error("Unexpected error:", globalError);
        Swal.fire({
          customClass: {
            container: "my-swal",
          },
          icon: "error",
          title: "Oops...",
          text: "An unexpected error occurred!",
          padding: "1em",
          color: "red",
        });
      } finally {
        setIsLoading(false);
      }
    }
  };
  const handleKeyPress = (e) => {
    const { name, type } = e.target;
    const charCode = e.keyCode || e.which;

    if (name === "userName") {
      if (/[^a-zA-Z\s]/.test(e.key)) {
        e.preventDefault();
      }
    } else if (type === "number" || name === "userPhoneNumber") {
      if ([69, 101, 43, 45, 46].includes(charCode)) {
        e.preventDefault();
      }
    }
  };

  return (
    <div>
      <Dialog open={isModalOpen} maxWidth="xl">
        <div
          className={`flex justify-between items-center ${Styles.vendorModalColor}`}
        >
          <DialogTitle>
            <span className="text-lg md:text-2xl font-bold">
              Installation Partner Form
            </span>
          </DialogTitle>
          <div
            onClick={handleClose}
            className="mx-5 my-4"
            style={{ cursor: "pointer" }}
          >
            <Cross />
          </div>
        </div>
        <DialogContent className={Styles.vendorModalColor}>
          <form onSubmit={handleSubmit}>
            <div className={Styles.formstyling}>
              <h4 className="mb-4 font-bold text-xl">Basic Details</h4>

              <Grid container spacing={4}>
                <Grid item xs={12} sm={6} md={4}>
                  <CustomInput
                    name="name"
                    placeholder="Enter Name"
                    title="Name *"
                    size="small"
                    required
                    onChange={(e) => {
                      const value = e.target.value;

                      if (
                        !value.startsWith(" ") &&
                        /^[A-Za-z\s]*$/.test(value)
                      ) {
                        handleInputChange(e);
                      }
                    }}
                    onBlur={(e) => {
                      emptyInputCheck(e.target.name, e.target.value);
                      if (saveButtonClicked) validateForm();
                    }}
                    // errorMessage={errors.name ? "Please Enter Name" : null}
                    error={errors.name}
                    value={formData?.name}
                  />
                  {errors.name && (
                    <div
                      className="font-normal text-[0.75rem] leading-[1.66] tracking-[0.03em] text-left mt-[4px] mr-[14px] mb-0 ml-[14px] text-[var(--error-color)]"
                      style={{ color: "var(--error-color) !important" }}
                    >
                      Please Enter Name
                    </div>
                  )}
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <InputLabel
                    error={errors.gender}
                    style={{
                      fontWeight: "500",
                      color: errors.gender
                        ? "var(--error-color)"
                        : "var(--heading-color)",
                    }}
                  >
                    Gender *
                  </InputLabel>

                  <FormControl
                    fullWidth
                    size="small"
                    sx={{
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#b0b0b0", // Set border color
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#b0b0b0", // Keep border color on focus
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#b0b0b0", // Keep border color on hover
                      },
                      "& .MuiOutlinedInput-root": {
                        "&:hover fieldset": {
                          borderColor: "#b0b0b0", // Ensure hover state is consistent
                        },
                      },
                      marginTop: "0.5rem",
                    }}
                    error={!!errors.gender} // Boolean for error state
                    onBlur={(e) => {
                      emptyInputCheck(e.target.name, e.target.value);
                      if (saveButtonClicked) {
                        validateForm();
                      }
                    }}
                  >
                    <Select
                      inputProps={{
                        "aria-label": "Without label",
                      }}
                      displayEmpty
                      name="gender"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#b0b0b0", // Set border color
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#b0b0b0", // Keep border color on focus
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#b0b0b0", // Keep border color on hover
                        },
                        "& .MuiOutlinedInput-root": {
                          "&:hover fieldset": {
                            borderColor: "#b0b0b0", // Ensure hover state is consistent
                          },
                          marginTop: "0.5rem",
                        },
                      }}
                      style={{ color: formData?.gender ? "" : "#a2a2a2" }}
                      value={formData?.gender || ""}
                      onChange={handleInputChange}
                      renderValue={(selected) => {
                        if (!selected) {
                          return (
                            <p className="text-[1rem] text-[var(--light-gray)]">
                              Select Gender
                            </p>
                          );
                        }
                        return selected;
                      }}
                    >
                      {/* Gender options */}
                      <MenuItem
                        value="Male"
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        Male
                        {formData?.gender === "Male" && (
                          <CheckIcon sx={{ color: "#418cff" }} />
                        )}
                      </MenuItem>
                      <MenuItem
                        value="Female"
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        Female
                        {formData?.gender === "Female" && (
                          <CheckIcon sx={{ color: "#418cff" }} />
                        )}
                      </MenuItem>
                      <MenuItem
                        value="Other"
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        Other
                        {formData?.gender === "Other" && (
                          <CheckIcon sx={{ color: "#418cff" }} />
                        )}
                      </MenuItem>
                      {/* <MenuItem value="Male">Male</MenuItem>
                        <MenuItem value="Female">Female</MenuItem>
                        <MenuItem value="Other">Other</MenuItem> */}
                    </Select>
                  </FormControl>

                  {errors.gender && (
                    <p className="font-normal text-[0.75rem] leading-[1.66] tracking-[0.03em] text-left mt-[4px] mr-[14px] mb-0 ml-[14px] text-[var(--error-color)]">
                      {errors.gender}
                    </p>
                  )}
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <CustomInput
                    name="dateOfBirth"
                    placeholder="Enter Date of Birth"
                    title="Date of Birth *"
                    size="small"
                    type="date"
                    onChange={(e) => handleInputChange(e)}
                    value={formData?.dateOfBirth}
                    max={maxDate}
                    sx={{
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#b0b0b0", // Set border color
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#b0b0b0", // Keep border color on focus
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#b0b0b0", // Keep border color on hover
                      },
                      "& .MuiOutlinedInput-root": {
                        "&:hover fieldset": {
                          borderColor: "#b0b0b0", // Ensure hover state is consistent
                        },
                      },
                    }}
                    style={{ color: formData?.dateOfBirth ? "" : "#a2a2a2" }}
                    // errorMessage={
                    //   errors.dateOfBirth ? "Please Enter Your Date" : null
                    // }
                    error={errors.dateOfBirth}
                    onBlur={(e) => {
                      emptyInputCheck(e.target.name, e.target.value);
                      if (saveButtonClicked) validateForm();
                    }}
                  />
                  {errors.dateOfBirth && (
                    <p className="font-normal text-[0.75rem] leading-[1.66] tracking-[0.03em] text-left mt-[4px] mr-[14px] mb-0 ml-[14px] text-[var(--error-color)]">
                      {errors.dateOfBirth}
                    </p>
                  )}
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <InputLabel
                    error={errors.experience}
                    style={{
                      fontWeight: "500",
                      color: errors.experience
                        ? "var(--error-color)"
                        : "var(--heading-color)",
                      marginBottom: "8px",
                    }}
                  >
                    Experience *
                  </InputLabel>
                  <FormControl
                    fullWidth
                    size="small"
                    error={!!errors.experience} // Boolean for error state
                    onBlur={(e) => {
                      emptyInputCheck(e.target.name, e.target.value);
                      if (saveButtonClicked) {
                        validateForm();
                      }
                    }}
                  >
                    <Select
                      inputProps={{
                        "aria-label": "Without label",
                      }}
                      displayEmpty
                      name="experience"
                      value={formData?.experience || ""}
                      onChange={handleInputChange}
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#b0b0b0", // Set border color
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#b0b0b0", // Keep border color on focus
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#b0b0b0", // Keep border color on hover
                        },
                        "& .MuiOutlinedInput-root": {
                          "&:hover fieldset": {
                            borderColor: "#b0b0b0", // Ensure hover state is consistent
                          },
                        },
                        marginTop: "0.5px",
                      }}
                      style={{ color: formData?.experience ? "" : "#a2a2a2" }}
                      renderValue={(selected) => {
                        if (!selected) {
                          return (
                            <p className="text-[1rem] text-[var(--light-gray)]">
                              Select Your Experience
                            </p>
                          );
                        }
                        return selected;
                      }}
                    >
                      {/* Gender options */}
                      <MenuItem
                        value="0-5"
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        0-5
                        {formData?.experience === "0-5" && (
                          <CheckIcon sx={{ color: "#418cff" }} />
                        )}
                      </MenuItem>
                      <MenuItem
                        value="6-10"
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        6-10
                        {formData?.experience === "6-10" && (
                          <CheckIcon sx={{ color: "#418cff" }} />
                        )}
                      </MenuItem>
                      <MenuItem
                        value="11-15"
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        11-15
                        {formData?.experience === "11-15" && (
                          <CheckIcon sx={{ color: "#418cff" }} />
                        )}
                      </MenuItem>
                      <MenuItem
                        value="16-20"
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        16-20
                        {formData?.experience === "16-20" && (
                          <CheckIcon sx={{ color: "#418cff" }} />
                        )}
                      </MenuItem>
                    </Select>
                  </FormControl>

                  {errors.experience && (
                    <p className="font-normal text-[0.75rem] leading-[1.66] tracking-[0.03em] text-left mt-[4px] mr-[14px] mb-0 ml-[14px] text-[var(--error-color)]">
                      {errors.experience}
                    </p>
                  )}
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <GlobalDropdownField
                    name="priorKnowledgeOfInstallation"
                    label="Prior Knowledge of Installation"
                    value={formData?.priorKnowledgeOfInstallation}
                    onChange={(e) =>
                      handleInputChange({
                        target: {
                          name: e.target.name,
                          value: e.target.value,
                        },
                      })
                    }
                    placeholder="Select"
                    options={[
                      { value: true, label: "Yes" },
                      { value: false, label: "No" },
                    ]}
                    variant="citySelect"
                    renderValueFn={(selected) => {
                      if (selected === true) return "Yes";
                      if (selected === "false") return "No";
                      return "Select";
                    }}
                    error={!!errors.priorKnowledgeOfInstallation}
                    errorMessage={errors.priorKnowledgeOfInstallation}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <GlobalDropdownField
                    name="itiCourse"
                    label="ITI Course Completed"
                    value={formData?.itiCourse}
                    onChange={(e) =>
                      handleInputChange({
                        target: {
                          name: e.target.name,
                          value: e.target.value,
                        },
                      })
                    }
                    placeholder="Select Course"
                    options={
                      itiCoursesList?.map((course) => {
                        const [key, value] = Object.entries(course)[0];
                        return { value, label: value };
                      }) || []
                    }
                    variant="citySelect"
                    renderValueFn={(selected) => selected || "Select Course"}
                    error={!!errors.itiCourse}
                    errorMessage={errors.itiCourse}
                  />
                </Grid>
              </Grid>
            </div>
            <div className={Styles.formstyling}>
              <h4 className="mb-4 font-bold text-xl">Contact Details</h4>

              <Grid container spacing={4}>
                <Grid item xs={12} sm={6} md={4}>
                  <CustomInput
                    name="phoneNumber"
                    placeholder="Enter Phone Number"
                    title="Phone Number *"
                    type="number"
                    size="small"
                    onChange={(e) => {
                      if (!e.target.value.startsWith(" ")) {
                        // &&
                        // e.target.value.length < 11
                        handleInputChange(e);
                      }
                    }}
                    onKeyPress={(e) => handleKeyPress(e)}
                    onBlur={(e) => {
                      emptyInputCheck(e.target.name, e.target.value);
                      if (saveButtonClicked) validateForm();
                    }}
                    value={formData?.phoneNumber}
                    error={errors.phoneNumber}
                    onFocus={handleFocus}
                    onWheel={(e) => e.preventDefault()}
                  />
                  {errors.phoneNumber && (
                    <p className="font-normal text-[0.75rem] leading-[1.66] tracking-[0.03em] text-left mt-[4px] mr-[14px] mb-0 ml-[14px] text-[var(--error-color)]">
                      {errors.phoneNumber}
                    </p>
                  )}
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <CustomInput
                    type="email"
                    name="emailAddress"
                    placeholder="Enter Email Address"
                    title="Email Address *"
                    size="small"
                    onChange={(e) => {
                      if (!e.target.value.startsWith(" ")) {
                        handleInputChange(e);
                      }
                    }}
                    value={formData?.emailAddress}
                    // errorMessage={
                    //   errors.emailAddress ? "Please Enter Email" : null
                    // }
                    error={errors.emailAddress}
                    onBlur={(e) => {
                      emptyInputCheck(e.target.name, e.target.value);
                      if (saveButtonClicked) validateForm();
                    }}
                    required
                  />
                  {errors.emailAddress && (
                    <p className="font-normal text-[0.75rem] leading-[1.66] tracking-[0.03em] text-left mt-[4px] mr-[14px] mb-0 ml-[14px] text-[var(--error-color)]">
                      {errors.emailAddress}
                    </p>
                  )}
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <CustomInput
                    name="address"
                    placeholder="Enter Address"
                    title="Address *"
                    size="small"
                    onChange={(e) => {
                      if (!e.target.value.startsWith(" ")) {
                        handleInputChange(e);
                      }
                    }}
                    value={formData?.address}
                    // errorMessage={
                    //   errors.address ? "Please Enter Your Address" : null
                    // }
                    error={errors.address}
                    onBlur={(e) => {
                      emptyInputCheck(e.target.name, e.target.value);
                      if (saveButtonClicked) validateForm();
                    }}
                  />
                  {errors.address && (
                    <p className="font-normal text-[0.75rem] leading-[1.66] tracking-[0.03em] text-left mt-[4px] mr-[14px] mb-0 ml-[14px] text-[var(--error-color)]">
                      {errors.address}
                    </p>
                  )}
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <GlobalDropdownField
                    name="state"
                    label="State *"
                    value={formData?.state || ""}
                    onChange={(e) => {
                      handleInputChange({
                        target: {
                          name: "state",
                          value: e.target.value,
                        },
                      });
                    }}
                    placeholder="State"
                    options={
                      statecityData?.map((state) => ({
                        value: state.name,
                        label: state.name,
                      })) || []
                    }
                    variant="citySelect"
                    renderValueFn={(selected) => selected || "State"}
                    error={!!errors.state}
                    errorMessage={errors.state}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <GlobalDropdownField
                    name="city"
                    label="City *"
                    value={formData?.city || ""}
                    onChange={(e) =>
                      handleInputChange({
                        target: {
                          name: e.target.name,
                          value: e.target.value,
                        },
                      })
                    }
                    placeholder="City"
                    options={
                      cityArray?.map((city) => ({
                        value: city.name,
                        label: city.name,
                      })) || []
                    }
                    variant="citySelect"
                    renderValueFn={(selected) => selected || "City"}
                    error={!!errors.city}
                    errorMessage={errors.city}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <CustomInput
                    name="zipCode"
                    placeholder="Enter Zip Code"
                    title="Zip Code *"
                    type="number"
                    size="small"
                    onKeyDown={(e) => {
                      // Prevent ArrowUp, ArrowDown, e, E, +, - keys
                      if (
                        ["ArrowUp", "ArrowDown", "e", "E", "+", "-"].includes(
                          e.key,
                        )
                      ) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow empty values and validate zip code
                      if (value === "" || validate(value, "zipcode")) {
                        handleInputChange(e);
                      }
                    }}
                    onBlur={(e) => {
                      emptyInputCheck(e.target.name, e.target.value);
                      if (saveButtonClicked) validateForm();
                    }}
                    value={formData?.zipCode}
                    error={errors.zipCode}
                    onFocus={handleFocus}
                    onWheel={(e) => e.preventDefault()} // Prevent mouse wheel input
                    onKeyPress={(e) => {
                      // Prevent e, E, +, - characters
                      if (!validate(e.key, "numberInput")) {
                        e.preventDefault();
                      }
                    }}
                  />
                  {errors.zipCode && (
                    <p className="font-normal text-[0.75rem] leading-[1.66] tracking-[0.03em] text-left mt-[4px] mr-[14px] mb-0 ml-[14px] text-[var(--error-color)]">
                      {errors.zipCode}
                    </p>
                  )}
                </Grid>
              </Grid>
            </div>

            <div className={`${Styles.formstyling} `}>
              <h4 className="mb-4 font-bold text-xl">Other Details</h4>

              <Grid container spacing={4}>
                <Grid item xs={12} sm={6} md={4}>
                  <CustomInput
                    name="aadhaarCardNumber"
                    placeholder="Enter Aadhaar Card Number"
                    title="Aadhaar Card Number *"
                    size="small"
                    onChange={(e) => {
                      if (
                        !e.target.value.startsWith(" ") &&
                        e.target.value.length < 13
                      ) {
                        handleInputChange(e);
                      }
                    }}
                    onBlur={(e) => {
                      emptyInputCheck(e.target.name, e.target.value);
                      if (saveButtonClicked) validateForm();
                    }}
                    value={formData?.aadhaarCardNumber}
                    required
                    type="number"
                    error={errors.aadhaarCardNumber}
                    onFocus={handleFocus}
                    onWheel={(e) => e.preventDefault()}
                    onKeyDown={(e) => {
                      // Prevent ArrowUp, ArrowDown, e, E, +, - keys
                      if (
                        ["ArrowUp", "ArrowDown", "e", "E", "+", "-"].includes(
                          e.key,
                        )
                      ) {
                        e.preventDefault();
                      }
                    }}
                  />
                  {errors.aadhaarCardNumber && (
                    <p className="font-normal text-[0.75rem] leading-[1.66] tracking-[0.03em] text-left mt-[4px] mr-[14px] mb-0 ml-[14px] text-[var(--error-color)]">
                      Please Enter Your Aadhaar Card Number
                    </p>
                  )}
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <CustomInput
                    name="bankDetails.bankName"
                    placeholder="Bank Name"
                    title="Bank Name"
                    size="small"
                    onChange={(e) => {
                      const value = e.target.value;

                      if (
                        !e.target.value.startsWith(" ") &&
                        /^[A-Za-z\s]*$/.test(value)
                      ) {
                        handleInputChange(e);
                      }
                    }}
                    value={formData.bankDetails.bankName}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <CustomInput
                    name="bankDetails.bankHolderName"
                    placeholder="Enter Name"
                    title="Bank Account Holder Name"
                    size="small"
                    maxLength={50}
                    onChange={(e) => {
                      const value = e.target.value;

                      if (
                        !value.startsWith(" ") &&
                        /^[A-Za-z\s]*$/.test(value)
                      ) {
                        handleInputChange(e);
                      }
                    }}
                    value={formData.bankDetails.bankHolderName}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <CustomInput
                    name="bankDetails.accountNumber"
                    placeholder="Enter Account Number"
                    title="Bank Account Number"
                    type="number"
                    size="small"
                    onChange={(e) => {
                      if (
                        !e.target.value.startsWith(" ") &&
                        e.target.value.length < 17
                      ) {
                        handleInputChange(e);
                      }
                    }}
                    onKeyDown={(e) => {
                      // Prevent ArrowUp, ArrowDown, e, E, +, - keys
                      if (
                        ["ArrowUp", "ArrowDown", "e", "E", "+", "-"].includes(
                          e.key,
                        )
                      ) {
                        e.preventDefault();
                      }
                    }}
                    value={formData.bankDetails.accountNumber}
                    onKeyPress={(e) => handleKeyPress(e)}
                    onFocus={handleFocus}
                    onWheel={(e) => e.preventDefault()}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <CustomInput
                    name="bankDetails.IFSC"
                    placeholder="Enter IFSC Code"
                    title="IFSC Code"
                    size="small"
                    maxLength={20}
                    onChange={(e) => {
                      if (
                        !e.target.value.startsWith(" ") &&
                        e.target.value.length <= 11
                      ) {
                        handleInputChange(e);
                      }
                    }}
                    value={formData.bankDetails.IFSC}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <CustomInput
                    name="bankDetails.panNumber"
                    placeholder="Enter Pan Number"
                    title="Pan Number"
                    // type="number"
                    size="small"
                    onChange={(e) => {
                      if (
                        !e.target.value.startsWith(" ") &&
                        e.target.value.length < 11
                      ) {
                        handleInputChange(e);
                      }
                    }}
                    value={formData.bankDetails.panNumber}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <GlobalDropdownField
                    name="status"
                    label="Status"
                    value={formData?.status || ""}
                    onChange={(e) =>
                      handleInputChange({
                        target: {
                          name: e.target.name,
                          value: e.target.value,
                        },
                      })
                    }
                    placeholder="Select Status"
                    options={[
                      { value: "Active", label: "Active" },
                      { value: "Inactive", label: "Inactive" },
                      { value: "Blacklisted", label: "Blacklisted" },
                    ]}
                    variant="citySearch"
                    renderValueFn={(selected) => {
                      if (!selected) {
                        return (
                          <p className="text-[1rem] text-[var(--light-gray)]">
                            Select Status
                          </p>
                        );
                      }
                      return selected;
                    }}
                    renderOptionFn={(option) => (
                      <MenuItem
                        key={option.value}
                        value={option.value}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        {option.label}
                        {formData?.status === option.value && (
                          <CheckIcon sx={{ color: "#418cff" }} />
                        )}
                      </MenuItem>
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <GlobalDropdownField
                    name="ipCategory"
                    label=" Category"
                    value={formData.ipCategory || ""}
                    onChange={(e) =>
                      handleInputChange({
                        target: {
                          name: e.target.name,
                          value: e.target.value,
                        },
                      })
                    }
                    placeholder="Select IP Category"
                    options={[
                      {
                        value: "Signage Installer",
                        label: "Signage Installer",
                      },
                      {
                        value: "Onsite Fabricator",
                        label: "Onsite Fabricator",
                      },
                      { value: "ACP Installer", label: "ACP Installer" },
                      { value: "Electrician", label: "Electrician" },
                    ]}
                    variant="citySearch"
                    renderValueFn={(selected) => {
                      if (!selected) {
                        return (
                          <p className="text-[1rem] text-[var(--light-gray)]">
                            Select Category
                          </p>
                        );
                      }
                      return selected;
                    }}
                    renderOptionFn={(option) => (
                      <MenuItem
                        key={option.value}
                        value={option.value}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        {option.label}
                        {formData?.ipCategory === option.value && (
                          <CheckIcon sx={{ color: "#418cff" }} />
                        )}
                      </MenuItem>
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <CustomInput
                    name="bankDetails.installationRate"
                    placeholder="Enter Installation Rate"
                    title="Installation Rate"
                    type="number"
                    size="small"
                    onChange={(e) => {
                      if (
                        !e.target.value.startsWith(" ") &&
                        e.target.value.length < 17
                      ) {
                        handleInputChange(e);
                      }
                    }}
                    onKeyDown={(e) => {
                      // Prevent ArrowUp, ArrowDown, e, E, +, - keys
                      if (
                        ["ArrowUp", "ArrowDown", "e", "E", "+", "-"].includes(
                          e.key,
                        )
                      ) {
                        e.preventDefault();
                      }
                    }}
                    value={formData.bankDetails.installationRate}
                    onKeyPress={(e) => handleKeyPress(e)}
                    onFocus={handleFocus}
                    onWheel={(e) => e.preventDefault()}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <GlobalDropdownField
                    name="vendorId"
                    label="Associated Vendor"
                    value={formData?.vendorId || ""}
                    onChange={(e) =>
                      handleInputChange({
                        target: {
                          name: e.target.name,
                          value: e.target.value,
                        },
                      })
                    }
                    placeholder="Select Vendor"
                    options={vpList.map((ele) => {
                      return { value: ele.id, label: ele.vendorBusinessName };
                    })}
                    variant="citySearch"
                    renderValueFn={(selected) => {
                      if (!selected) {
                        return (
                          <p className="text-[1rem] text-[var(--light-gray)]">
                            Select Vendor
                          </p>
                        );
                      }
                      const selectedVendor = vpList.find(
                        (ele) => ele.id === selected,
                      );

                      return (
                        selectedVendor?.vendorBusinessName || "Select Vendor"
                      );
                    }}
                    renderOptionFn={(option) => (
                      <MenuItem
                        key={option.value}
                        value={option.value}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        {option.label}
                        {formData?.vendorId === option.value && (
                          <CheckIcon sx={{ color: "#418cff" }} />
                        )}
                      </MenuItem>
                    )}
                  />
                </Grid>

                {formData?.status === "Blacklisted" && (
                  <Grid item xs={12} sm={6} md={4}>
                    <CustomInput
                      placeholder="Enter Reason For Blacklisted "
                      title="Reason For Blacklisted *"
                      name="reasonForBlacklisted"
                      type="text"
                      size="small"
                      value={formData?.reasonForBlacklisted}
                      errorMessage={
                        errors.reasonForBlacklisted ? (
                          <span style={{ color: "var(--error-color)" }}>
                            Please Enter Reason For Blacklisted
                          </span>
                        ) : null
                      }
                      error={errors.reasonForBlacklisted}
                      onChange={handleInputChange}
                      multiline
                      InputProps={{ inputProps: { min: 0 } }}
                    />
                  </Grid>
                )}
              </Grid>
            </div>
            <Grid container spacing={2} sx={{ marginTop: 0.5 }}>
              <Grid item xs={12} sm={6} className={Styles.noPaddingTop}>
                <div className={Styles.formstyling}>
                  <div className=" sm:flex-row md:flex ">
                    <div className="pl-[10px] md:pl-[20px] pr-[20px] py-0">
                      <span
                        className={`${
                          errors.profilePhoto
                            ? "text-[var(--error-color)]"
                            : "text-gray-500 text-[20px] font-bold"
                        }`}
                      >
                        Profile Photo *
                      </span>
                      <MinMaxFileUploader
                        initialFiles={formData.profilePhoto} // Prepopulate with profile photo
                        onFilesUpload={(urls) =>
                          setFormData({
                            ...formData,
                            profilePhoto: urls, // Store the image as a Data URL for preview
                          })
                        }
                        typeOfFilesAllowed={"image/*"} // Specify allowed file types (only images)
                        maxFiles={1} // Limit to only 1 file
                      />
                      {errors.profilePhoto && (
                        <p className="font-normal text-[0.75rem] leading-[1.66] tracking-[0.03em] text-left  mr-[14px] mb-0 ml-[14px] text-[var(--error-color)]">
                          {errors.profilePhoto}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </Grid>
              {/* 10th certificate */}
              <Grid item xs={12} sm={6} className={Styles.noPaddingTop}>
                <div className={Styles.formstyling}>
                  <div className=" sm:flex-row md:flex ">
                    <div className="pl-[10px] md:pl-[20px] pr-[20px] py-0">
                      <span className="text-gray-500 text-[20px] font-bold">
                        10th Pass Certificate
                      </span>
                      <MinMaxFileUploader
                        initialFiles={formData.tenthCertificate}
                        onFilesUpload={(urls) =>
                          setFormData({
                            ...formData,
                            tenthCertificate: urls, // Store the image as a Data URL for preview
                          })
                        }
                        typeOfFilesAllowed={["image/*", "application/pdf"]}
                        maxFiles={1} // Limit to only 1 file
                      />
                    </div>
                  </div>
                </div>
              </Grid>
              {/* 12th certificate */}
              <Grid item xs={12} sm={6} className={Styles.noPaddingTop}>
                <div className={Styles.formstyling}>
                  <div className=" sm:flex-row md:flex ">
                    <div className="pl-[10px] md:pl-[20px] pr-[20px] py-0">
                      <span className="text-gray-500 text-[20px] font-bold">
                        12th Pass Certificate
                      </span>
                      <MinMaxFileUploader
                        initialFiles={formData.twelfthCertificate} // Prepopulate with profile photo
                        onFilesUpload={(urls) =>
                          setFormData({
                            ...formData,
                            twelfthCertificate: urls, // Store the image as a Data URL for preview
                          })
                        }
                        typeOfFilesAllowed={["image/*", "application/pdf"]} // Specify allowed file types (only images and pdf)
                        maxFiles={1} // Limit to only 1 file
                      />
                    </div>
                  </div>
                </div>
              </Grid>
              {/* ITI certificate */}
              <Grid item xs={12} sm={6} className={Styles.noPaddingTop}>
                <div className={Styles.formstyling}>
                  <div className=" sm:flex-row md:flex ">
                    <div className="pl-[10px] md:pl-[20px] pr-[20px] py-0">
                      <span className="text-gray-500 text-[20px] font-bold">
                        ITI Certificate
                      </span>
                      <MinMaxFileUploader
                        initialFiles={formData.itiCertificate} // Prepopulate with profile photo
                        onFilesUpload={(urls) =>
                          setFormData({
                            ...formData,
                            itiCertificate: urls, // Store the image as a Data URL for preview
                          })
                        }
                        typeOfFilesAllowed={["image/*", "application/pdf"]}
                        maxFiles={1} // Limit to only 1 file
                      />
                    </div>
                  </div>
                </div>
              </Grid>
              {/* Diploma certificate */}
              <Grid item xs={12} sm={6} className={Styles.noPaddingTop}>
                <div className={Styles.formstyling}>
                  <div className=" sm:flex-row md:flex ">
                    <div className="pl-[10px] md:pl-[20px] pr-[20px] py-0">
                      <span className="text-gray-500 text-[20px] font-bold">
                        Diploma
                      </span>
                      <MinMaxFileUploader
                        initialFiles={formData.diplomaCertificate}
                        onFilesUpload={(urls) =>
                          setFormData({
                            ...formData,
                            diplomaCertificate: urls, // Store the image as a Data URL for preview
                          })
                        }
                        typeOfFilesAllowed={["image/*", "application/pdf"]}
                        maxFiles={1} // Limit to only 1 file
                      />
                    </div>
                  </div>
                </div>
              </Grid>
              {/* Graduation certificate */}
              <Grid item xs={12} sm={6} className={Styles.noPaddingTop}>
                <div className={Styles.formstyling}>
                  <div className=" sm:flex-row md:flex ">
                    <div className="pl-[10px] md:pl-[20px] pr-[20px] py-0">
                      <span className="text-gray-500 text-[20px] font-bold">
                        Graduation Certificate
                      </span>
                      <MinMaxFileUploader
                        initialFiles={formData.graduationCertificate}
                        onFilesUpload={(urls) =>
                          setFormData({
                            ...formData,
                            graduationCertificate: urls, // Store the image as a Data URL for preview
                          })
                        }
                        typeOfFilesAllowed={["image/*", "application/pdf"]}
                        maxFiles={1} // Limit to only 1 file
                      />
                    </div>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} className={Styles.noPaddingTop}>
                <div className={Styles.formstyling}>
                  <div className=" sm:flex-row md:flex">
                    <div className="pl-[10px] md:pl-[20px] pr-[20px] py-0">
                      <span className="text-gray-500 text-[20px] font-bold">
                        Cancelled Cheque Photo
                      </span>
                      <MinMaxFileUploader
                        initialFiles={formData.bankDetails.cancelledCheque} // Prepopulate with cheque photo
                        onFilesUpload={(urls) =>
                          setFormData({
                            ...formData,
                            bankDetails: {
                              ...formData.bankDetails,
                              cancelledCheque: urls,
                            },
                          })
                        } // Update formData with uploaded cheque photo
                        typeOfFilesAllowed={"image/*,video/*"} // Allow images and videos
                        maxFiles={1} // Limit to only 1 file
                      />
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </form>
        </DialogContent>

        <DialogActions>
          <div className="w-30">
            <GlobalButton
              variant="secondary"
              size="medium"
              onClick={handleClose}
            >
              {`Close`}
            </GlobalButton>
          </div>
          <div className="w-30">
            <GlobalButton
              variant="primary"
              size="medium"
              isLoading={isLoading}
              disabled={isLoading}
              // disabled={disableSaveButton}
              onClick={(e) => {
                // setIsLoading(true)
                setSaveButtonClicked(true);
                handleSubmit(e);
              }}
            >
              {selectedInstallationPartnerData._id ? "UPDATE" : "SAVE"}
            </GlobalButton>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default InstallationPartnerOnboardingForm;
